import { StyledHeader, StyledLogo } from './styles';

import darsLogo from '../../resources/images/dars-logo.svg';

export const AppHeader = () => (
    <StyledHeader>
        <StyledLogo src={darsLogo} alt="DARS" title="DARS" />
    </StyledHeader>
);
